export default __webpack_public_path__ + "static/media/nor_6.ee968834.svg";